// extracted by mini-css-extract-plugin
export default {"baseScreen":"onfido-sdk-ui-ActiveVideo-BaseScreen-baseScreen"};